<template>
  <div class="wxMiddlePage solveBfc">
    <div class="title">
      <van-skeleton :row="1" row-width="40%" />
    </div>
    <div class="message">
      <van-skeleton :row="2" :row-width="messageArr" />
    </div>

    <div class="bntBox">
      <van-skeleton :row="2" :row-width="bntBoxArr" />
    </div>
    <div class="bottom">
      <van-skeleton :row="1" row-width="60%" />
    </div>
  </div>
</template>
    
    <script>
import { payLinke } from "@/api/buy";
export default {
  name: "wxMiddlePage",
  components: {},
  data() {
    return {
      pay_obj: {},
      messageArr: ["80%", "20%"],
      bntBoxArr: ["100%", "60%"],
    };
  },

  mounted() {
    this.pay_obj = this.$route.query;

    const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent);
    if (isWeixinBrowser) {
      alert("请用浏览器打开");
    } else {
      this.tryOpenApp();
    }
  },

  methods: {
    tryOpenApp() {
      payLinke({ aliPayKey: this.pay_obj.aliPayKey }).then((res) => {
        if (res.code == 200) {
          location.href = res.data.aliPayValue;
        }
      });
      //
    },

    // 在页面的适当位置调用 tryOpenApp 函数
  },
};
</script>
    
    <style lang="less" scoped>
.solveBfc::before,
.solveBfc::after {
  content: "";
  /*table既可以解决塌陷又可以解决外边距重叠*/
  display: table;
  clear: both;
}
.wxMiddlePage {
  padding: 0 12px;
  .title {
    width: 100%;
    margin-top: 12px;
  }
  .message {
    margin-top: 20px;
    .van-skeleton__row {
      margin: 12px auto;
    }
  }
  .bntBox {
    margin-top: 40px;
    .van-skeleton__row {
      margin: 12px auto;
    }
  }
  .bottom {
    width: 350px;
    height: 30px;
    position: fixed;
    max-width: 414px;
    bottom: 0;
  }
  .van-skeleton__row {
    margin: 0 auto;
  }
  .van-skeleton {
    height: 100%;
  }
}
</style>
    